// App
new Vue({
  el: "#app",
  data: function() {
    return {
      scrolling: {
        startAt: 0,
        sections: {},
        active: {}
      }
    };
  },
  methods: {
    isActiveSection(index) {
      const isActive = _.get(this.scrolling.active, index, false);

      return isActive === true;
    },
    activeSection() {
      let activeIndex = -1;

      _.each(this.scrolling.active, (value, index) => {
        if (value === true) activeIndex = _.parseInt(index);
      });

      return activeIndex;
    },
    prevSection() {
      const currentIndex = this.activeSection();
      if (currentIndex <= 0) return;

      // Kind of confusing, this is offset by one so technically correct
      const prevIndex = currentIndex;

      this.$scrollTo(`#section-0${prevIndex}`, 300);
    },
    nextSection() {
      const currentIndex = this.activeSection();
      if (currentIndex >= this.scrolling.active.length) return;

      // Kind of confusing, this is offset by one so technically +2 is correct
      const nextIndex = currentIndex + 2;

      this.$scrollTo(`#section-0${nextIndex}`, 300);
    },
    scrollCalculations() {
      this.scrolling.sections = document.querySelectorAll(".page__section");
      const startAt =
        this.scrolling.sections[0].getBoundingClientRect().top + window.scrollY;
      this.scrolling.startAt = _.ceil(startAt);

      _.each(this.scrolling.sections, (el, index) => {
        _.set(this.scrolling.active, index, false);
      });
    },
    handleScroll() {
      // Scrollnav sections
      _.each(this.scrolling.sections, (el, index) => {
        const offset = el.getBoundingClientRect();
        const bottom = offset.bottom - this.scrolling.startAt;
        const top = offset.top - this.scrolling.startAt;
        let isActive;

        if (top >= 0 || bottom < 0) {
          isActive = false;
        }
        if (top <= 0 && bottom > 0) {
          isActive = true;
        }

        _.set(this.scrolling.active, index, isActive);
      });

      this.$forceUpdate();
    }
  },
  mounted() {
    this.scrollCalculations();
    this.handleScroll();

    window.addEventListener(
      "scroll",
      _.debounce(this.handleScroll, 10, {
        leading: false,
        trailing: true
      })
    );
  }
});
